<script>
import AppQrReader from "@/components/AppQrReader.vue";

export default {
  name: "NotesPage",
  components: {
    AppQrReader
  },
  data() {
    return {
      qr: false,
      queryString: '',
      batchId: 23,
    }
  },
  computed: {
    isIntern() {
      return this.$store.getters.isIntern
    },
  },
  methods: {
    showQrReader() {
      this.qr = true;
    },
    qrRead(params) {
      if (params.qrString) {
        this.setBagId(params.qrString)
        this.saveBagLoading()
      }
      this.qr = false
    },
  }
}
</script>

<template>
  <h1>Notizen und Fotos</h1>
  <h2 class="pt-0">Charge auswählen</h2>
  <ul
      class="nav mt-0">
    <li
        v-if="isIntern"
        @click="showQrReader" class="qr">
      QR-Code
      <img src="@/assets/images/icon-qr-code.svg"/>
    </li>
  </ul>
  <form @submit.prevent="false" class="row">
    <div class="input-group col-8 mt-3 mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="queryString">Suche</label>
      </div>
      <input v-model="queryString" @keyup="searchBatch" class="form-control form-control-lg"
             id="queryString" placeholder="">
      <div class="input-group-append">
      </div>
    </div>
  </form>
  <div
      v-if="batchId"
      class="row">
    <h1 class="mt-4">Charge {{ batchId }}</h1>
  </div>

  <app-qr-reader v-if="qr" :doEmit="true" @qrRead="qrRead"/>
</template>